const apiurl = 'https://s5qhtatq3k.execute-api.eu-west-2.amazonaws.com/development'

export const environment = {
  baseurl: 'https://cf8razzb93.execute-api.eu-west-2.amazonaws.com/development/v1',
  production: true,
  baseApiUrl: 'https://s5qhtatq3k.execute-api.eu-west-2.amazonaws.com/development',
  executionAPI: 'https://0grmuahnwi.execute-api.eu-west-2.amazonaws.com/development/executeTest',
  journeyAPI: apiurl + '/v1/journey',
  // journey api without pagination
  allJourneyAPI: apiurl + '/journey',
  historyAPI: apiurl + '/execution-report-history',
  reportAPI: apiurl + '/execution-report',
  projectAPI: 'https://xbw1y2d4fl.execute-api.eu-west-2.amazonaws.com/development/project',
  agentAPI: 'https://cf8razzb93.execute-api.eu-west-2.amazonaws.com/development/agents',
  userAPI: 'https://hbjqff8146.execute-api.eu-west-2.amazonaws.com/development/user',
  customerAPI: 'https://xbw1y2d4fl.execute-api.eu-west-2.amazonaws.com/development/customer',
  settingsUploadImage: 'https://xbw1y2d4fl.execute-api.eu-west-2.amazonaws.com/development/upload-logo',
  imageRepoURL: 'https://ecast-client.s3.eu-west-2.amazonaws.com',
  screenshotRepoURL: 'https://testplex-dev-s3.s3.eu-west-2.amazonaws.com',
  configureJourney: apiurl+'/configure-journey', 
   //stage 1
   getAllJourneys: apiurl+'/stage1/pagejourney',
   createJourneys: apiurl+'/stage1/journeypage',
   getSelectedJourneys: apiurl+'/stage1/journey',
   deleteStep: apiurl+'/scenario-page',
   deleteJourney: apiurl+'/stage1/journey',
   getScenario: apiurl+'/scenario',
   saveStage1: apiurl+'/journey',
   createFeatureFile: apiurl+'/featurefile',
   sitemapPageAPI: apiurl+'/pageflow',
   executionNameAPI: apiurl+'/current-execution',
   viewExecute: apiurl+'/current-execution',
   createJourneyWithoutTemplate: apiurl+'/stage1/journey',
   createNewScenario: apiurl+'/scenario',
   updateScenario: apiurl+'/scenario-page',
   getIpAddressAPI: 'https://ipinfo.io/json',
   addStep: apiurl+'/step',
   createJourneyTag: apiurl+'/journey-tag',
   scenarioTag: apiurl+'/scenario-tag',
   deleteFeature: apiurl+'/feature',
   stepSuggestions: apiurl+'/getStepSuggestions',
  downloadFiles: apiurl+'/download-featurefile',
  createPage: apiurl+'/sitemap',
  getPageWithoutJourney:  apiurl+"/pages",
  deletePage: apiurl+"/sitemap-delete",
  updateProject: apiurl+"/project/update",
  stopExecutionApi: apiurl + "/stop-execution",
  getJourneyTags: apiurl + "/journeytags"



  };
